export const defaultLogArgsSerializer = (args) => args
    .map((arg) => {
    try {
        return String(arg);
    }
    catch (_err) {
        return '';
    }
})
    .join(' ');
